define('ua/listeners/partner-conversion',[
    'ua/ua-wrapper',
    'adlhelpers'
], function(ua, ADL) {
    'use strict';

    /*
     * EVENTS:
     *
     * user.account.created
     * listing.onboarding.submit
     *
     */
    function setupListeners(edap) {
        var unknownStr = 'unknown';

        edap.on('user.account.created', function(data) {
            var adl = new ADL(data),
                userType = adl.isSetGet('newusertype') || unknownStr,
                stubOrFullVals = {
                    true: 'stub account',
                    false: 'full account',
                    default: unknownStr
                },
                marketingOptOutVals = {
                    true: 'remarketing opt-out',
                    false: 'no remarketing opt-out',
                    default: 'remarketing opt-out not presented'
                },
                stubOrFull,
                marketingOptOut;

            stubOrFull = stubOrFullVals[(adl.isSetGet('stubaccount') || 'default')];
            marketingOptOut = marketingOptOutVals[(adl.isSetGet('marketingoptout') || 'default')];

            if (stubOrFull === unknownStr) {
                edap.error('\'user.account.created\' triggered without \'stubaccount\' property set');
            }

            if (userType === unknownStr) {
                edap.error('\'user.account.created\' triggered without \'newusertype\' property set');
            }

            ua.sendEvent(
                'account creation',
                userType,
                [stubOrFull, marketingOptOut].join(':'),
                undefined,
                undefined,
                data
            );
        });

        edap.on('listing.onboarding.submit', function(data) {
            var adl = new ADL(data),
                newSupplierVals = {
                    true: 'new supplier',
                    false: 'existing supplier',
                    default: unknownStr
                },
                newSupplier;

            newSupplier = newSupplierVals[(adl.isSetGet('newsupplier') || 'default')];

            if (newSupplier === unknownStr) {
                edap.error('\'listing.onboarding.submit\' triggered without \'newsupplier\' property set');
            }

            ua.sendEvent(
                'supplier onboarding completion',
                newSupplier,
                undefined,
                undefined,
                undefined,
                data
            );
        });
    }

    return {
        setupListeners: setupListeners
    };
});

